import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';

class QrCode extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isFixed: false,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = dom => {
        let offsetTop = dom.offsetTop;

        if (dom.offsetParent) {
            offsetTop += this.getOffsetTop(dom.offsetParent);
        }

        return offsetTop;
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        const domArr = document.querySelectorAll('[data-title]');

        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        this.tabsTop = this.getOffsetTop(domArr[0]);

        if (currentTop > this.tabsTop) {
            this.setState({ isFixed: true });
        } else {
            this.setState({ isFixed: false });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { isFixed } = this.state;
        const {
            content: { url, title, src, width, height },
        } = this.props;

        return (
            <div className={isFixed ? styles.fix_qrCode_box : styles.qrCode_box}>
                <div className={styles.title}>{title}</div>
                <div className={styles.line} />
                <a className={styles.img_box} href={url} target="_blank">
                    <img src={src} width={width} height={height} />
                </a>
                <div className={styles.tip}>扫码下载 看新闻</div>
            </div>
        );
    }
}

export default errorBoundary(QrCode);
